/**
 * Whether this engine accepts a `fetch(..., { keepalive: true })` that needs a
 * CORS preflight, which every request carrying `Authorization`,
 * `Content-Type: application/json`, `traceparent` or `baggage` does.
 *
 * vingreact#1457: Chromium 80 and older refuse such a request even same-origin
 * (the promise rejects with `TypeError: Failed to fetch`; the console logs
 * "Preflight request for request with keepalive specified is currently not
 * supported"). Measured on staging 2026-10-10: 80.0.3987.0 refuses;
 * 81.0.4044.0, 92 and 107 send. Edge, Opera and Samsung carry a `Chrome/`
 * token and follow it; `CriOS/` is WebKit and does not.
 *
 * This is the one place that decides; no other module sniffs the UA for this.
 */
export function keepaliveAllowsPreflight(
  userAgent: string | undefined = typeof navigator === 'undefined' ? undefined : navigator.userAgent,
): boolean {
  if (!userAgent) return true;
  const match = /(?:HeadlessChrome|Chrome)\/(\d+)/.exec(userAgent);
  if (!match || match[1] === undefined) return true;
  return Number(match[1]) > 80;
}
